// extracted by mini-css-extract-plugin
export var background = "hero-module--background--PKVbu";
export var heroImage = "hero-module--heroImage--uI3h9";